import { Wkt } from 'wicket'
import 'wicket/wicket-gmap3'

export default function wicket() {
  return Wkt
}
